export const svgLinks = {
    logo: "/svgs/logo.svg",
    describeit: "/svgs/describeit.svg",
    instantcode: "/svgs/instantcode.svg",
    lightning: "/svgs/lightning.svg",
    aldino: "/svgs/aldino.svg",
    shah: "/svgs/shah.svg",
    steve: "/svgs/steve.svg",
    logo2: "/svgs/logo2.svg",
    logo3: "/svgs/logo3.svg",
  };
  
  export const imgLinks = {
    qoonitysc: "./images/qoonitysc.png",
    instantcode: "./images/instantcode.png",
    howitworks1: "./images/howitworks1.png",
  };
  